import React from 'react';

import {
  CmBox,
  CmButton,
  CmFormControl,
  CmFormLabel,
  CmInput,
} from '@/components/uiParts';
import { useInput } from '@/hooks/Form';

interface Props {
  onSubmit: (email: string) => Promise<void>;
}

export const ForgotPasswordForm: React.FC<Props> = ({
  onSubmit,
}): JSX.Element => {
  const [email, emailProps] = useInput('', 'email');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    await onSubmit(email);
  };

  return (
    <CmBox as="form" mx={4} onSubmit={handleSubmit}>
      <CmFormControl mb={4}>
        <CmFormLabel>メールアドレス</CmFormLabel>
        <CmInput {...emailProps} isRequired />
      </CmFormControl>
      {/*
       // @ts-ignore TS2590 */}
      <CmButton type="submit" width="100%" textAlign="center" mb={3}>
        送信する
      </CmButton>
    </CmBox>
  );
};
